import get from '../../helpers/data_layer/get';

const formatCurrency = () => {
  const srpPrices = document.querySelectorAll('.listing-card__price-value');
  const currencySymbol = get('site.currency_symbol');
  srpPrices.forEach((price) => {
    const priceString = price.innerText;
    const updatedString = priceString.replace(
      /[$\xA2-\xA5]/gi,
      `<strong class="listing-card__currency">${currencySymbol}</strong>`,
    );
    price.innerHTML = updatedString;
  });
};

export default formatCurrency;
